import Section from "../Section";
import Parallax from '../global/Parallax';

export default class ImageWithTextBlock extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const parallaxEl = element.querySelector('.parallax-enabled');
    if (parallaxEl) {
      this.parallax = new Parallax(theme, parallaxEl);
    }
  }
}
